// extracted by mini-css-extract-plugin
export var center = "_57-2";
export var clickableRow = "_57-5";
export var expandedRow = "_57-7";
export var hoverable = "_57-4";
export var left = "_57-1";
export var right = "_57-3";
export var row = "_57-0";
export var selectedRow = "_57-6";
export var summaryRow = "_57-8";